/**
 * Whether a keystroke was meant as text rather than as a command.
 *
 * It is the whole of spec 081 US2: `j` and `k` are letters, `/` already puts
 * the cursor in a text field, and a key that steals a character mid-word
 * corrupts input the reader believed was safe. That is worse than having no
 * shortcut at all.
 *
 * Shared since spec 125, when the task drawer's Shift+Enter needed the same
 * answer and reaching into the Tasks page's feature for it made a module cycle.
 * That shortcut went with the drawer's next-action button (2026-10-06).
 */
export function isTextEntry(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}
